import {Dispatcher} from "../../stem-core/base/Dispatcher";

// For good integration between CookieCondition and setCookie builtin function.
export const setCookieDispatcher = new Dispatcher();


export function setCookie(key: string, value: string, age: number): void {
    document.cookie = `${key}=${value}; path=/; max-age=${age};`;
    setCookieDispatcher.dispatch();
}

export function getCookie(key: string): string {
    let cookies = (document.cookie || "").split(";");
    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(key + "=")) {
            return cookie.substring(key.length + 1);
        }
    }
    return "";
}
